import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    max-width: 496px;
    margin: 0 auto;
    text-align: center;
`;

export const Text = styled.p`
    font-size: ${props => props.theme.fontSize.medium};
    font-weight: 400;
    line-height: 22px;
    margin-bottom: ${props => props.theme.spacing.large};
`;

export const Highlighted = styled.span`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-weight: bold;
`;
